module.exports = __webpack_public_path__ + "static/media/the-etho-homepage-1.df87d45e.jpg";